import React from 'react';

interface PdaPageProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  actionLabel?: string;
  actionIcon?: React.ReactNode;
  onAction?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  pageClassName?: string;
}

function PdaPage({
  title,
  subtitle,
  onBack,
  actionLabel,
  actionIcon,
  onAction,
  children,
  footer,
  pageClassName,
}: PdaPageProps) {
  return (
    <div className={pageClassName ? `pda-page ${pageClassName}` : 'pda-page'}>
      <header className="pda-header">
        {onBack ? (
          <button
            aria-label="返回"
            className="header-btn header-btn--ghost header-btn--icon"
            onClick={onBack}
            type="button"
          >
            <span aria-hidden="true" className="header-btn__chevron" />
          </button>
        ) : null}

        <div className="pda-header__main">
          <div className="pda-header__title">{title}</div>
          {subtitle ? <div className="pda-header__subtitle">{subtitle}</div> : null}
        </div>

        {actionLabel && onAction ? (
          <button className="header-btn header-btn--ghost header-btn--compact" onClick={onAction} type="button">
            {actionIcon}
            {actionLabel}
          </button>
        ) : null}
      </header>

      <main className="pda-content">{children}</main>
      {footer ? <div className="pda-footer">{footer}</div> : null}
    </div>
  );
}

export default PdaPage;
